import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ChangeStatusAndCancelApprovalModal: LoadableType<{
	approverData: Array<{
		name: string;
		src?: string;
		email?: string;
	}>;
	onCancelApproval: () => void;
	onClose: () => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ChangeStatusAndCancelApprovalModal" */ '../src/Modals/ChangeStatusAndCancelApprovalModal.tsx'
			)
		).ChangeStatusAndCancelApprovalModal,
});
